import StatsCard from "../components/StatsCard/StatsCard"
import { Accordion, AccordionItem } from "@heroui/react"
import useStats from "../hooks/useStats"
import classes from "../styles/Home.module.scss"

const Home = () => {
  const {
    teachers,
    students,
    events,
    liveEvents,
    liveTests,
    subscriptions,
    totalCompanyFee,
  } = useStats()

  return (
    <div className={classes.root}>
      <Accordion selectionMode="multiple" defaultExpandedKeys={["2"]}>
        <AccordionItem key="1" aria-label="נתונים" title="נתונים">
          <div className={classes.stats}>
            <StatsCard title="מנויים" value={subscriptions} isPrice />
            <StatsCard title="עמלות אשראי" value={totalCompanyFee} isPrice />
            <StatsCard title="מורים" value={teachers} />
            <StatsCard title="תלמידים" value={students} />
            <StatsCard title="סך הכל שיעורים" value={events} />
          </div>
        </AccordionItem>
        <AccordionItem key="2" aria-label="מידע לייב" title="מידע לייב">
          <div className={classes.stats}>
            <StatsCard title="אירועים" value={liveEvents} />
            <StatsCard title="טסטים" value={liveTests} />
          </div>
        </AccordionItem>
      </Accordion>
    </div>
  )
}

export default Home
